import { createApp, defineAsyncComponent } from 'vue';
import VueImage from './Components/VueImage';
import RevealMenu from './Components/RevealMenu';
import ImageModal from './Components/ImageModal'
import Modal from "./Components/Modal";

const SlideShow = defineAsyncComponent(() => import('./Components/SlideShow'));
const Carousel = defineAsyncComponent(() => import('./Components/Carousel'));

/**
 * Create a fresh Vue application instance and attach it to the page
 */
const app = createApp({})

app.component('v-image', VueImage);
app.component('reveal-menu', RevealMenu);
app.component('slide-show', SlideShow);
app.component('carousel', Carousel);
app.component('image-modal', ImageModal);
app.component('modal', Modal);

app.mount("#app");